/* ============================================================
   DE RAIL — dingen naast elkaar, en je schuift erlangs.

   Eén mechaniek voor drie plekken: de vier handelingen in het atelier (op een
   groot scherm vastgezet en door je scroll naar links getrokken), de ezels
   (een diavoorstelling die vanzelf doorloopt tot je hem aanraakt) en het
   verhaal op de productpagina op een telefoon (vegen, lezen, vegen).

   DE REGELS
   · Het spoor is een gewone scrollcontainer met scroll-snap. Zonder JavaScript
     kun je dus gewoon vegen; dit bestand voegt alleen stippen, pijlen, het
     automatische doorlopen en het vastzetten toe.
   · Automatisch doorlopen stopt zodra iemand iets doet (aanraken, scrollen,
     klikken, toetsenbord) en bij prefers-reduced-motion loopt er niets vanzelf.
     Het loopt ook alleen als de rail in beeld is.
   · Het vastzetten (data-rail-pin) gebruikt de veer uit de rest van de site:
     snelheid, geen lerp; het rolt uit als je stopt met scrollen.
   · window.scrollY is op dit thema altijd 0; lees document.scrollingElement.
   ============================================================ */
(function () {
  const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scroller = () => document.scrollingElement || document.documentElement;
  const rails = [];

  document.querySelectorAll('[data-rail]').forEach(start);

  function start(rail) {
    if (rail.dataset.railAan) return;
    rail.dataset.railAan = '1';
    const spoor = rail.querySelector('[data-rail-spoor]');
    if (!spoor) return;
    const dias = [...spoor.children].filter(e => e.nodeType === 1);
    if (dias.length < 2) { rail.classList.add('rail--een'); return; }

    /* ---------- stippen en pijlen ---------- */
    const stippenVak = rail.querySelector('[data-rail-stippen]');
    const stippen = [];
    if (stippenVak) {
      dias.forEach((d, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rail__stip';
        b.setAttribute('aria-label', `Naar ${i + 1} van ${dias.length}`);
        b.addEventListener('click', () => ga(i, true));
        stippenVak.appendChild(b);
        stippen.push(b);
      });
    }
    let index = 0;
    function zet(i) {
      index = i;
      stippen.forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false'));
      dias.forEach((d, k) => d.classList.toggle('is-aan', k === i));
    }
    zet(0);

    const vorige = rail.querySelector('[data-rail-vorige]');
    const volgende = rail.querySelector('[data-rail-volgende]');
    if (vorige) vorige.addEventListener('click', () => ga(index - 1, true));
    if (volgende) volgende.addEventListener('click', () => ga(index + 1, true));

    /* ---------- vastzetten op een groot scherm ---------- */
    const pin = rail.hasAttribute('data-rail-pin') && matchMedia('(min-width: 901px)').matches && !rustig;
    let overflow = 0, top = 0, doel = 0, glad = 0, snelheid = 0, loopt = false;

    function meetPin() {
      overflow = Math.max(0, spoor.scrollWidth - spoor.clientWidth);
      rail.style.height = overflow > 0 ? (innerHeight + overflow) + 'px' : '';
      const r = rail.getBoundingClientRect();
      top = r.top + scroller().scrollTop;
    }
    function tikPin() {
      /* kritisch gedempt (0,05 / 0,58, ζ ≈ 0,94): het spoor volgt het wiel
         zonder doorschieten, zonder naloop bij omkeren, en rolt uit als je stopt */
      snelheid = (snelheid + (doel - glad) * 0.05) * 0.58;
      glad += snelheid;
      if (Math.abs(doel - glad) < 0.0005 && Math.abs(snelheid) < 0.0005) { glad = doel; snelheid = 0; loopt = false; }
      spoor.style.transform = `translate3d(${(-overflow * glad).toFixed(1)}px,0,0)`;
      const i = Math.round(glad * (dias.length - 1));
      if (i !== index) zet(i);
      if (loopt) requestAnimationFrame(tikPin);
    }
    function scrollPin() {
      if (!overflow) return;
      const p = (scroller().scrollTop - top) / overflow;
      doel = p < 0 ? 0 : p > 1 ? 1 : p;
      if (!loopt) { loopt = true; requestAnimationFrame(tikPin); }
    }
    if (pin) {
      rail.classList.add('rail--pin');
      meetPin();
      if (overflow > 0) {
        addEventListener('scroll', scrollPin, { passive: true });
        addEventListener('resize', () => { meetPin(); scrollPin(); }, { passive: true });
        scrollPin();
      } else {
        rail.classList.remove('rail--pin');
      }
    }

    /* ---------- op alle andere schermen: het spoor scrolt zelf ---------- */
    function ga(i, hand) {
      const n = (i + dias.length) % dias.length;
      if (rail.classList.contains('rail--pin') && overflow > 0) {
        /* vastgezet: de pagina scrollen tot dat blad in beeld staat */
        const y = top + overflow * (n / (dias.length - 1));
        if (window.donqVeerScroll) window.donqVeerScroll(y);
        else scroller().scrollTo({ top: y, behavior: rustig ? 'auto' : 'smooth' });
      } else {
        spoor.scrollTo({ left: dias[n].offsetLeft - spoor.offsetLeft, behavior: rustig ? 'auto' : 'smooth' });
      }
      zet(n);
      if (hand) stopVoorgoed();
    }

    if (!rail.classList.contains('rail--pin') && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => {
        es.forEach(e => { if (e.isIntersecting && e.intersectionRatio >= 0.55) zet(dias.indexOf(e.target)); });
      }, { root: spoor, threshold: [0.55] });
      dias.forEach(d => io.observe(d));
    }

    /* past alles al naast elkaar, dan valt er niets te schuiven: geen
       bediening tonen en niets laten lopen */
    const pastAl = () => !rail.classList.contains('rail--pin') && spoor.scrollWidth <= spoor.clientWidth + 12;
    const bediening = rail.querySelector('[data-rail-bediening]');
    function toonBediening() { if (bediening) bediening.hidden = pastAl(); }
    toonBediening();
    addEventListener('resize', toonBediening, { passive: true });

    /* ---------- vanzelf doorlopen ---------- */
    const auto = parseInt(rail.dataset.railAuto, 10) || 0;
    let timer = null, gestopt = false;
    function loop() {
      if (!auto || rustig || gestopt || timer || pastAl()) return;
      timer = setInterval(() => { if (!document.hidden) ga(index + 1, false); }, auto);
    }
    function pauze() { if (timer) { clearInterval(timer); timer = null; } }
    function stopVoorgoed() { gestopt = true; pauze(); }
    if (auto && !rustig) {
      if ('IntersectionObserver' in window) {
        const zicht = new IntersectionObserver(es => { es.some(e => e.isIntersecting) ? loop() : pauze(); }, { threshold: 0.35 });
        zicht.observe(rail);
      } else loop();
      rail.addEventListener('pointerenter', pauze);
      rail.addEventListener('pointerleave', loop);
      rail.addEventListener('focusin', stopVoorgoed);
      spoor.addEventListener('touchstart', stopVoorgoed, { passive: true });
      spoor.addEventListener('wheel', stopVoorgoed, { passive: true });
      spoor.addEventListener('pointerdown', stopVoorgoed);
    }

    /* ---------- slepen met de muis, want een muiswiel scrolt niet opzij ---------- */
    if (!rail.classList.contains('rail--pin') && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      let x0 = 0, s0 = 0, sleept = false;
      spoor.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; sleept = true; x0 = e.clientX; s0 = spoor.scrollLeft; spoor.classList.add('is-sleep'); });
      addEventListener('pointermove', e => { if (!sleept) return; spoor.scrollLeft = s0 - (e.clientX - x0); });
      addEventListener('pointerup', () => { if (!sleept) return; sleept = false; spoor.classList.remove('is-sleep'); });
    }

    rails.push(rail);
  }

  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('[data-rail]').forEach(start);
  });
})();
